import { render } from "./cFile.vue?vue&type=template&id=12fee274&scoped=true"
import script from "./cFile.vue?vue&type=script&lang=js"
export * from "./cFile.vue?vue&type=script&lang=js"

import "./cFile.vue?vue&type=style&index=0&id=12fee274&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12fee274"],['__file',"src/components/cmp/cFile/cFile.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "12fee274"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('12fee274', __exports__)) {
    api.reload('12fee274', __exports__)
  }
  
  module.hot.accept("./cFile.vue?vue&type=template&id=12fee274&scoped=true", () => {
    api.rerender('12fee274', render)
  })

}


export default __exports__